const rootPath = "/"
const homePath = "/home"

export { rootPath, homePath }
